import React from "react";
import { Popup } from "semantic-ui-react";
import infoIcon from "../../../assets/icons/info-i.svg";

export default function InfoPopup({
  info = (
    <img
      className="next-to-text"
      style={{ width: 22, height: 22, paddingBottom: 2 }}
      src={infoIcon}
      alt="info"
    />
  ),
  text = "",
  triggerSpacing = 0,
  isDisabled = false,
}) {
  return (
    <Popup
      className="popup-container"
      content={
        <div className="popup-container-content body-blue-text">{text}</div>
      }
      on={["hover", "click"]}
      hoverable={true}
      trigger={
        <span
          className="popup-hover-text next-to-text"
          style={{ margin: triggerSpacing }}
        >
          {info}
        </span>
      }
      disabled={isDisabled}
    />
  );
}
